import React, { Component } from 'react';
import PanelFrame from '../../../Common/PanelFrame';
import * as PIXI from 'pixi.js'
import PropTypes  from 'prop-types'
import './drawDashedLine';
import './SceneViewer.scss'
import { ErrorHandler } from '@/utils/Error/Handler'

import TemplateHelper from '@/utils/TemplateHelper'

class SceneViewer extends Component {
    canvasParent = null;
    app = null;
    canvas = null;
    canvasRoot = null;
    guide = null;
    footageGuide = null;
    backgroundImage = null;
    clientRect = null;
    hoveredLayer = -1;
    getRatio = () => {
        return this.props.templateHeight / this.props.templateWidth;
    }
    state = {
        dropImage: "",

        hoverX: 0,
        hoverY: 0,
        hoverImageURL: null,

        isVisibleVideoIcon: false
    }
    currentPos = null;

    getFootageContext = () => {
        const footageContext = {}
        if (this.props.material && this.props.material.Footage) {
            this.props.material.Footage.forEach(item => footageContext[item.Composition] = item)
        }
        return footageContext
    }

    componentDidMount() {
        this.clientRect = new PIXI.Rectangle(0, 0, 0, 0);

        this.app = new PIXI.Application(this.props.width, this.props.height, { backgroundColor: 0x5f5f5f, autoResize: true, forceCanvas: true });
        this.canvasParent.append(this.app.view);

        this.canvas = new PIXI.Graphics();
        //컨테이너 정의
        this.canvasRoot = new PIXI.Container();

        //가이드 박스 정의
        this.guide = new PIXI.Graphics();
        
        this.backgroundImage = new PIXI.Sprite(); // PIXI.Sprite.fromImage("https://test.io/wp-content/uploads/2017/02/testIO-logo-rgb.png");

        this.backgroundImage.anchor.set(0, 0);
        this.backgroundImage.width = this.props.templateWidth;
        this.backgroundImage.height = this.props.templateHeight;

        //Heierachy
        this.app.stage.addChild(this.canvas);
        this.canvas.addChild(this.canvasRoot);
        this.canvasRoot.addChild(this.backgroundImage);
        this.canvasRoot.addChild(this.guide);

        this.app.ticker.add((delta) => {
            this.updateCanvas();
        });

        this.setBackgroundImage();
    }

    componentWillUnmount() {
        if (this.app) {
            this.app.destroy(true, true)
        }
    }

    setBackgroundImage()
    {
        if(!this.props.scene) return;

        try {
            let imageURL = null
            if (this.props.preview && this.props.language === "ko") imageURL = this.props.preview
            else imageURL = TemplateHelper.getPreviewImage(this.props.scene, this.props.language)
    
            this.backgroundImage.texture = PIXI.Texture.fromImage(imageURL, '');
        }
        catch (e) {
            console.log(e)
        }

    }
    componentDidUpdate(){
        this.setBackgroundImage();
        //  this.updateFootageGuide();
    }
    //그리기 영역을 계산
    calculateCanvasRect = (width, height) => {
        var rect = new PIXI.Rectangle();

        if (width * this.getRatio() < height) {
            var reHeight = width * this.getRatio();

            rect.x = 0
            rect.y = height / 2 - reHeight / 2
            rect.width = width
            rect.height = reHeight;
        }
        else {
            var reWidth = height * (1 / this.getRatio());
            rect.x = width / 2 - reWidth / 2;
            rect.y = 0;
            rect.width = reWidth;
            rect.height = height;
        }

        return rect;
    };
    scaleFactor = 0;
    updateCanvas = () => {
        var newWidth = this.props.width;
        var newHeight = this.props.height;
        this.app.renderer.resize(newWidth, newHeight);

        this.scaleFactor = Math.min(
            newWidth / this.props.templateWidth,
            newHeight / this.props.templateHeight);

        this.canvas.clear();
        this.canvas.beginFill(0xffffff, 1);

        this.clientRect = this.calculateCanvasRect(newWidth, newHeight);

        this.canvas.drawRect(0, -1, this.clientRect.width, this.clientRect.height);




        this.canvas.endFill();

        this.canvas.x = this.clientRect.x;
        this.canvas.y = this.clientRect.y;

        this.canvasRoot.width = this.canvas.width;
        this.canvasRoot.height = this.canvas.height;

        this.canvasRoot.scale.set(this.scaleFactor);
        if (!this.props.scene) return;
        this.updateFootageGuide();

    };
    setGrapicBackground = (grapic, color, width, height, x, y) => {
        grapic.beginFill(color, 0.5);
        grapic.drawRect(x, y, width, height, 18, 10);
        grapic.endFill();
    }
    updateFootageGuide = () => {
        var style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 45,
            fontWeight: 'bold',
            fill: '#ffffff', // gradient

        });

        if (this.footageGuide) {
            this.footageGuide.destroy(true); // .removeChildren(0, this.footageGuide.children.length);
        }
        this.footageGuide = new PIXI.Container();
        this.canvasRoot.addChild(this.footageGuide);

        this.hoveredLayer = -1;
        var textIndex = 0;
        var footageIndex = 0;
        let isObjectOver = false;
        for (var i = 0; i < this.props.scene.Layers.length; i++) {
            var layer = this.props.scene.Layers[i];
            var index = 0;
            var color = -1;
            if (layer.Type === 'Text') {
                color = 0x8dc323;
                index = textIndex++;
            }
            else {
                color = 0xff9e56;
                index = footageIndex++;
            }

            var x = layer.Position.x; // Math.max(layer.Position.x / 100 * this.props.templateWidth,0); // canvas.width;
            var y = layer.Position.y; // Math.max(layer.Position.y / 100 * this.props.templateHeight,0); // canvas.height;

            var w = Math.abs(layer.Scale.w); //Math.min(this.props.templateWidth, layer.Width * this.props.templateWidth * Math.abs(layer.Scale.w) / 100); // canvas.width;
            var h = Math.abs(layer.Scale.h); // Math.min(this.props.templateHeight, layer.Height * this.props.templateHeight * Math.abs(layer.Scale.h) / 100);// canvas.height;
            var anchor_x = layer.Anchor.x;
            var anchor_y = layer.Anchor.y;

            if (x < 0) {
                anchor_x += Math.abs(x) / w
                x = 0
            }
            if (y < 0) {
                anchor_y += Math.abs(y) / h
                y = 0
            }

            var g = new PIXI.Graphics();
            g.lineStyle(6, color);
            g.drawDashRect(x, y, w, h, 18, 10);
            g.lineStyle(0, 0x00000);

            var rect = new PIXI.Rectangle(x - anchor_x * w, y - anchor_y * h, w, h);

      
            if (this.props.selectedLayer === i) {
                this.setGrapicBackground(g, color, w, h, x, y);
            } else if (this.currentPos != null && !isObjectOver) {
                if (rect.contains(this.currentPos.x, this.currentPos.y)) {
                    this.setGrapicBackground(g, color, w, h, x, y)
                    this.hoveredLayer = i;
                    isObjectOver=true;
                }
            }

           
            g.beginFill(0x000000, 0.25);
            g.drawRect(x, y, w, h);


            //circle draw
            g.lineStyle(0, 0x87e115);
            g.beginFill(color, 0.8);
            g.drawCircle(x + w / 2, y + h / 2, 30);

            var text = new PIXI.Text((index + 1).toString(), style);
            text.anchor.set(0.5, 0.5);
            text.position.set(x + w / 2, y + h / 2);

            g.endFill();


            g.addChild(text);

            g.pivot.set(anchor_x * w, anchor_y * h);

            this.footageGuide.addChild(g);
        }

    }

    getMousePos = (canvas, evt) => {
        var rect = canvas.getBoundingClientRect();
        return {
            x: parseFloat(evt.clientX - rect.left - this.clientRect.x) / this.scaleFactor,
            y: parseFloat(evt.clientY - rect.top - this.clientRect.y) / this.scaleFactor
        };
    }

    getFootageContext = () => {
        const footageContext = {}
        if (this.props.material && this.props.material.Footage) {
            this.props.material.Footage.forEach(item => footageContext[item.Composition] = item)
        }
        return footageContext
    }


    setCursor = option => {
        if (!this.canvasParent) return
        this.canvasParent.style.setProperty('cursor', option)
    }

    canvasMouseMove = (e) => {
        e.preventDefault();
        this.currentPos = this.getMousePos(this.app.view, e);
        this.setState({ hoverImageURL: null, isVisibleVideoIcon: false, hoverX: e.clientX, hoverY: e.clientY })

        if (!this.canvasParent || !this.props.scene || !this.props.scene.Layers || Number.isNaN(this.hoveredLayer) || !this.props.previewImageURL) return this.setCursor('default')

        var layer = this.props.scene.Layers[this.hoveredLayer];
        if (layer === undefined || layer.Type !== 'Footage') return this.setCursor('default')

        if (this.props.previewImageURL.hasOwnProperty(layer.Name)) {
            this.setCursor('pointer')
            this.setState({ hoverImageURL: this.props.previewImageURL[layer.Name] })
        }
        else {
            const footageContext = this.getFootageContext()
            if (footageContext && footageContext[layer.Name] && footageContext[layer.Name].Meta) {
                this.setState({ isVisibleVideoIcon: true })
            }
        }
    }

    canvasMouseLeave = () => {
        this.setCursor('default')
        this.currentPos = { x: -10000, y: -10000 }
        this.setState({ hoverImageURL: null, isVisibleVideoIcon: false })
    }

    canvasDragOver = (e) => {
        e.preventDefault();
        this.currentPos = this.getMousePos(this.app.view, e);
    }
    canvasDrop = (e) => {
        try {
            e.preventDefault();
            // var imageName = e.dataTransfer.getData('file');
            const mySourceData = JSON.parse(e.dataTransfer.getData('data'));
            if (!mySourceData) return;
    
            var layer = this.props.scene.Layers[this.hoveredLayer];
            if (layer === undefined || layer.Type !== 'Footage') return;
            this.props.cropImage(
                mySourceData, 
                layer.Name,
                (this.props.templateWidth * layer.Width) / (this.props.templateHeight * layer.Height), 
                this.hoveredLayer, 
                (blob, meta, videoThumbnail) => {
                    if (meta.source === "image") {
                        this.props.addFootageToMaterial({ comp: layer.Name, file: blob, name: blob.name.toLowerCase(), meta, imageThumbnail: videoThumbnail });
                        return;
                    }
                this.props.addFootageToMaterial({comp:layer.Name, file:blob, name:blob.name.toLowerCase(), meta, videoThumbnail});
            });
        }
        catch (e) {
            ErrorHandler(this, null, e, { log: true })
        }
    }

    canvasClick = e => {
        var layer = this.props.scene.Layers[this.hoveredLayer];
        if (layer === undefined) return
        const { layerSelectEvent, handleFocusTextArea } = this.props;
        const footageContext = this.getFootageContext()
        if (layer.Type === 'Footage') {
            this.props.changeMenu("workspace")

            if (!footageContext.hasOwnProperty(layer.Name)) return
            this.props.clickImage(
                footageContext[layer.Name],
                layer.Name,
                (this.props.templateWidth * layer.Width) / (this.props.templateHeight * layer.Height),
                this.hoveredLayer,
                (blob, meta, videoThumbnail) => {
                    if (meta.source === "image") {
                        this.props.addFootageToMaterial({ comp: layer.Name, file: blob, name: blob.name.toLowerCase(), meta, imageThumbnail: videoThumbnail });
                        return;
                    }
                    this.props.addFootageToMaterial({ comp: layer.Name, file: blob, name: blob.name.toLowerCase(), meta, videoThumbnail });
                })
        } else if (layer.Type === 'Text') {
            layerSelectEvent(this.hoveredLayer);
            handleFocusTextArea(layer.Name)
        }
    }

    render() {
        const templateInfoHeight = 21.5
        return (
            <PanelFrame className="scene-viewer-box" style={{
                minWidth: this.props.width + 'px',
                minHeight: this.props.height + templateInfoHeight + 'px',
                width: this.props.width + 'px',
                height: this.props.height + templateInfoHeight + 'px',
                margin: '10px',
                float: 'left',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px',
                overflow: 'hidden'
            }}>
                <div className='template-info'>
                    <span>[{this.props.videoName}]</span>
                    <span>{this.props.templateName}</span>
                </div>
                <div ref={ref => { this.canvasParent = ref; }} onDragOver={this.canvasDragOver} onMouseLeave={this.canvasMouseLeave} onMouseMove={this.canvasMouseMove} onDrop={this.canvasDrop} onClick={this.canvasClick}>  </div>
                {
                    this.state.hoverImageURL &&
                    <img className="hover-image" src={this.state.hoverImageURL} alt="" style={{ left: this.state.hoverX, top: this.state.hoverY }}></img>
                }
                {
                    this.state.isVisibleVideoIcon &&
                    <img className="hover-icon" src="https://front.videomonster.com/images-7cuytg20/web/videoUpload.png" alt="" style={{ left: this.state.hoverX, top: this.state.hoverY }}></img>
                }
            </PanelFrame>
        );
    }
}

SceneViewer.defaultProps = {
    width: 610,
    height: 345,
    scene: null,
    selectedLayer: -1
}

SceneViewer.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    scene: PropTypes.object,
    selectedLayer: PropTypes.number
}
export default SceneViewer;